import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Icon, Tooltip } from 'antd';
import cn from 'classnames';
import { ReactComponent as UnlinkIcon } from '../../../../../resource/LinkBrokenModern.svg';
import styles from './index.module.scss';

const UnlinkButton = ({ tooltipTitle, className, action }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(action);
  };

  return (
    <Tooltip title={tooltipTitle}>
      <Button
        shape="circle-outline"
        className={cn(styles.root, className)}
        onClick={handleClick}
      >
        <Icon component={UnlinkIcon} />
      </Button>
    </Tooltip>
  );
};

export default UnlinkButton;
